module.exports = __webpack_public_path__ + "static/gosugam-impact-f6f4244432b4cf336a00f525b3479078.jpg";